import { createClient } from "microcms-js-sdk";

export const getMicroCMSConnection = (serviceDomain: string, apiKey: string) => {
  return createClient({
    serviceDomain: serviceDomain,
    apiKey: apiKey,
  });
}